/// Auto-generated. Modifications will be overwritten.
/// Generated from core/document-schemas/DocumentsModel.yaml
export const MRZDocumentType = 'MRZ';
export const DeIdCardFrontDocumentType = 'DeIdCardFront';
export const DeIdCardBackDocumentType = 'DeIdCardBack';
export const DePassportDocumentType = 'DePassport';
export const DeDriverLicenseFrontDocumentType = 'DeDriverLicenseFront';
export const DeDriverLicenseBackDocumentType = 'DeDriverLicenseBack';
export const DeDriverLicenseBackCategoryDocumentType = 'Category';
export const DeDriverLicenseBackCategoriesDocumentType = 'Categories';
export const DeDriverLicenseBackCategoriesADocumentType = 'A';
export const DeDriverLicenseBackCategoriesA1DocumentType = 'A1';
export const DeDriverLicenseBackCategoriesA2DocumentType = 'A2';
export const DeDriverLicenseBackCategoriesAMDocumentType = 'AM';
export const DeDriverLicenseBackCategoriesBDocumentType = 'B';
export const DeDriverLicenseBackCategoriesB1DocumentType = 'B1';
export const DeDriverLicenseBackCategoriesBEDocumentType = 'BE';
export const DeDriverLicenseBackCategoriesCDocumentType = 'C';
export const DeDriverLicenseBackCategoriesC1DocumentType = 'C1';
export const DeDriverLicenseBackCategoriesC1EDocumentType = 'C1E';
export const DeDriverLicenseBackCategoriesCEDocumentType = 'CE';
export const DeDriverLicenseBackCategoriesDDocumentType = 'D';
export const DeDriverLicenseBackCategoriesD1DocumentType = 'D1';
export const DeDriverLicenseBackCategoriesD1EDocumentType = 'D1E';
export const DeDriverLicenseBackCategoriesDEDocumentType = 'DE';
export const DeDriverLicenseBackCategoriesLDocumentType = 'L';
export const DeDriverLicenseBackCategoriesTDocumentType = 'T';
export const DeResidencePermitFrontDocumentType = 'DeResidencePermitFront';
export const DeResidencePermitBackDocumentType = 'DeResidencePermitBack';
export const EuropeanHealthInsuranceCardDocumentType = 'EuropeanHealthInsuranceCard';
export const DeHealthInsuranceCardFrontDocumentType = 'DeHealthInsuranceCardFront';
/** MRZ part of the document */
export class MRZ {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return MRZDocumentType;
    }
    /** Birth date */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Check digit birth date */
    get checkDigitBirthDate() {
        return this.document.fields.find((f) => f.type.name === 'CheckDigitBirthDate');
    }
    /** Check digit document number */
    get checkDigitDocumentNumber() {
        return this.document.fields.find((f) => f.type.name === 'CheckDigitDocumentNumber');
    }
    /** Check digit expiry date */
    get checkDigitExpiryDate() {
        return this.document.fields.find((f) => f.type.name === 'CheckDigitExpiryDate');
    }
    /** Check  digit general */
    get checkDigitGeneral() {
        return this.document.fields.find((f) => f.type.name === 'CheckDigitGeneral');
    }
    /** Check digit personal number */
    get checkDigitPersonalNumber() {
        return this.document.fields.find((f) => f.type.name === 'CheckDigitPersonalNumber');
    }
    /** Date of issuance */
    get dateOfIssuance() {
        return this.document.fields.find((f) => f.type.name === 'DateOfIssuance');
    }
    /** Document number */
    get documentNumber() {
        return this.document.fields.find((f) => f.type.name === 'DocumentNumber');
    }
    /** Document type from the DocumentType enum */
    get documentType() {
        return this.document.fields.find((f) => f.type.name === 'DocumentType');
    }
    /** Document type code */
    get documentTypeCode() {
        return this.document.fields.find((f) => f.type.name === 'DocumentTypeCode');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Issuing authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Language code */
    get languageCode() {
        return this.document.fields.find((f) => f.type.name === 'LanguageCode');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Office of issuance */
    get officeOfIssuance() {
        return this.document.fields.find((f) => f.type.name === 'OfficeOfIssuance');
    }
    /** TD1 Optional field (line 2) */
    get optional1() {
        return this.document.fields.find((f) => f.type.name === 'Optional1');
    }
    /** TD1 Optional field (line 3) */
    get optional2() {
        return this.document.fields.find((f) => f.type.name === 'Optional2');
    }
    /** PIN code */
    get pinCode() {
        return this.document.fields.find((f) => f.type.name === 'PINCode');
    }
    /** Personal number */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** Travel document type */
    get travelDocType() {
        return this.document.fields.find((f) => f.type.name === 'TravelDocType');
    }
    /** Travel document type variant */
    get travelDocTypeVariant() {
        return this.document.fields.find((f) => f.type.name === 'TravelDocTypeVariant');
    }
    /** Unknown */
    get unknown() {
        return this.document.fields.find((f) => f.type.name === 'Unknown');
    }
    /** Version number */
    get versionNumber() {
        return this.document.fields.find((f) => f.type.name === 'VersionNumber');
    }
    /** MRV-A/MRV-B (Travel Visa) Optional field */
    get visaOptional() {
        return this.document.fields.find((f) => f.type.name === 'VisaOptional');
    }
}
/** German ID card, front side */
export class DeIdCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeIdCardFrontDocumentType;
    }
    /** Birth date */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Birthplace */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Six digit card access number */
    get cardAccessNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardAccessNumber');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Document ID number (in the top-right corner) */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Maiden name */
    get maidenName() {
        return this.document.fields.find((f) => f.type.name === 'MaidenName');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
}
/** German ID card, back side */
export class DeIdCardBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeIdCardBackDocumentType;
    }
    /** Address */
    get address() {
        return this.document.fields.find((f) => f.type.name === 'Address');
    }
    /** Eye color */
    get eyeColor() {
        return this.document.fields.find((f) => f.type.name === 'EyeColor');
    }
    /** Height */
    get height() {
        return this.document.fields.find((f) => f.type.name === 'Height');
    }
    /** Issue date */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Issuing authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Pseudonym */
    get pseudonym() {
        return this.document.fields.find((f) => f.type.name === 'Pseudonym');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
}
/** German travel passport (Reisepass) */
export class DePassport {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DePassportDocumentType;
    }
    /** Birth date */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Birthplace */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Country code */
    get countryCode() {
        return this.document.fields.find((f) => f.type.name === 'CountryCode');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Document ID number (in the top-right corner) */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Issue date */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Issuing authority */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Maiden name */
    get maidenName() {
        return this.document.fields.find((f) => f.type.name === 'MaidenName');
    }
    /** Nationality */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Passport type */
    get passportType() {
        return this.document.fields.find((f) => f.type.name === 'PassportType');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
}
/** German driver license (Führerschein), front side */
export class DeDriverLicenseFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeDriverLicenseFrontDocumentType;
    }
    /** Birth date (Field 3.) */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Birthplace (Field 3.) */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Expiry date (Field 4b.) */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Given names (Field 2.) */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Document ID number (in the top-right corner, Field 5.) */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Issue date (Field 4a.) */
    get issueDate() {
        return this.document.fields.find((f) => f.type.name === 'IssueDate');
    }
    /** Issuing authority (Field 4c.) */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Driver's license categories (Field 9.) */
    get licenseCategories() {
        return this.document.fields.find((f) => f.type.name === 'LicenseCategories');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Serial number (Field 5b. on Driver Qualification Card) */
    get serialNumber() {
        return this.document.fields.find((f) => f.type.name === 'SerialNumber');
    }
    /** Signature image (Field 7.) */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname (Field 1.) */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
}
/** German driver license (Führerschein), back side */
export class DeDriverLicenseBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeDriverLicenseBackDocumentType;
    }
    /** Restrictions applied for the driver's license (Field 12.) */
    get restrictions() {
        return this.document.fields.find((f) => f.type.name === 'Restrictions');
    }
    /** The child document of type "Categories". */
    get categories() {
        const child = this.document.children.find((c) => c.type.name === 'Categories');
        return new DeDriverLicenseBack.Categories(child);
    }
}
(function (DeDriverLicenseBack) {
    /** A category row from the categories table */
    class Category {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        /** Restrictions (Column 12.) */
        get restrictions() {
            return this.document.fields.find((f) => f.type.name === 'Restrictions');
        }
        /** Valid from (Column 10.) */
        get validFrom() {
            return this.document.fields.find((f) => f.type.name === 'ValidFrom');
        }
        /** Valid until (Column 11.) */
        get validUntil() {
            return this.document.fields.find((f) => f.type.name === 'ValidUntil');
        }
    }
    DeDriverLicenseBack.Category = Category;
    /** Categories table row container */
    class Categories {
        get document() {
            return this._document;
        }
        constructor(document) {
            if (document.type.name !== this.requiredDocumentType()) {
                throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
            }
            this._document = document;
        }
        requiredDocumentType() {
            return DeDriverLicenseBackCategoriesDocumentType;
        }
        /** The child document of type "A". */
        get a() {
            const child = this.document.children.find((c) => c.type.name === 'A');
            return new DeDriverLicenseBack.Categories.A(child);
        }
        /** The child document of type "A1". */
        get a1() {
            const child = this.document.children.find((c) => c.type.name === 'A1');
            return new DeDriverLicenseBack.Categories.A1(child);
        }
        /** The child document of type "A2". */
        get a2() {
            const child = this.document.children.find((c) => c.type.name === 'A2');
            return new DeDriverLicenseBack.Categories.A2(child);
        }
        /** The child document of type "AM". */
        get am() {
            const child = this.document.children.find((c) => c.type.name === 'AM');
            return new DeDriverLicenseBack.Categories.AM(child);
        }
        /** The child document of type "B". */
        get b() {
            const child = this.document.children.find((c) => c.type.name === 'B');
            return new DeDriverLicenseBack.Categories.B(child);
        }
        /** The child document of type "B1". */
        get b1() {
            const child = this.document.children.find((c) => c.type.name === 'B1');
            return child ? new DeDriverLicenseBack.Categories.B1(child) : undefined;
        }
        /** The child document of type "BE". */
        get be() {
            const child = this.document.children.find((c) => c.type.name === 'BE');
            return new DeDriverLicenseBack.Categories.BE(child);
        }
        /** The child document of type "C". */
        get c() {
            const child = this.document.children.find((c) => c.type.name === 'C');
            return new DeDriverLicenseBack.Categories.C(child);
        }
        /** The child document of type "C1". */
        get c1() {
            const child = this.document.children.find((c) => c.type.name === 'C1');
            return new DeDriverLicenseBack.Categories.C1(child);
        }
        /** The child document of type "C1E". */
        get c1E() {
            const child = this.document.children.find((c) => c.type.name === 'C1E');
            return new DeDriverLicenseBack.Categories.C1E(child);
        }
        /** The child document of type "CE". */
        get ce() {
            const child = this.document.children.find((c) => c.type.name === 'CE');
            return new DeDriverLicenseBack.Categories.CE(child);
        }
        /** The child document of type "D". */
        get d() {
            const child = this.document.children.find((c) => c.type.name === 'D');
            return new DeDriverLicenseBack.Categories.D(child);
        }
        /** The child document of type "D1". */
        get d1() {
            const child = this.document.children.find((c) => c.type.name === 'D1');
            return new DeDriverLicenseBack.Categories.D1(child);
        }
        /** The child document of type "D1E". */
        get d1E() {
            const child = this.document.children.find((c) => c.type.name === 'D1E');
            return new DeDriverLicenseBack.Categories.D1E(child);
        }
        /** The child document of type "DE". */
        get de() {
            const child = this.document.children.find((c) => c.type.name === 'DE');
            return new DeDriverLicenseBack.Categories.DE(child);
        }
        /** The child document of type "L". */
        get l() {
            const child = this.document.children.find((c) => c.type.name === 'L');
            return new DeDriverLicenseBack.Categories.L(child);
        }
        /** The child document of type "T". */
        get t() {
            const child = this.document.children.find((c) => c.type.name === 'T');
            return new DeDriverLicenseBack.Categories.T(child);
        }
    }
    DeDriverLicenseBack.Categories = Categories;
    (function (Categories) {
        /** DeDriverLicenseBack.Categories.A */
        class A extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesADocumentType;
            }
        }
        Categories.A = A;
        /** DeDriverLicenseBack.Categories.A1 */
        class A1 extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesA1DocumentType;
            }
        }
        Categories.A1 = A1;
        /** DeDriverLicenseBack.Categories.A2 */
        class A2 extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesA2DocumentType;
            }
        }
        Categories.A2 = A2;
        /** DeDriverLicenseBack.Categories.AM */
        class AM extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesAMDocumentType;
            }
        }
        Categories.AM = AM;
        /** DeDriverLicenseBack.Categories.B */
        class B extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesBDocumentType;
            }
        }
        Categories.B = B;
        /** DeDriverLicenseBack.Categories.B1 */
        class B1 extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesB1DocumentType;
            }
        }
        Categories.B1 = B1;
        /** DeDriverLicenseBack.Categories.BE */
        class BE extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesBEDocumentType;
            }
        }
        Categories.BE = BE;
        /** DeDriverLicenseBack.Categories.C */
        class C extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesCDocumentType;
            }
        }
        Categories.C = C;
        /** DeDriverLicenseBack.Categories.C1 */
        class C1 extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesC1DocumentType;
            }
        }
        Categories.C1 = C1;
        /** DeDriverLicenseBack.Categories.C1E */
        class C1E extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesC1EDocumentType;
            }
        }
        Categories.C1E = C1E;
        /** DeDriverLicenseBack.Categories.CE */
        class CE extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesCEDocumentType;
            }
        }
        Categories.CE = CE;
        /** DeDriverLicenseBack.Categories.D */
        class D extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesDDocumentType;
            }
        }
        Categories.D = D;
        /** DeDriverLicenseBack.Categories.D1 */
        class D1 extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesD1DocumentType;
            }
        }
        Categories.D1 = D1;
        /** DeDriverLicenseBack.Categories.D1E */
        class D1E extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesD1EDocumentType;
            }
        }
        Categories.D1E = D1E;
        /** DeDriverLicenseBack.Categories.DE */
        class DE extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesDEDocumentType;
            }
        }
        Categories.DE = DE;
        /** DeDriverLicenseBack.Categories.L */
        class L extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesLDocumentType;
            }
        }
        Categories.L = L;
        /** DeDriverLicenseBack.Categories.T */
        class T extends Category {
            constructor(document) {
                super(document);
            }
            requiredDocumentType() {
                return DeDriverLicenseBackCategoriesTDocumentType;
            }
        }
        Categories.T = T;
    })(Categories = DeDriverLicenseBack.Categories || (DeDriverLicenseBack.Categories = {}));
})(DeDriverLicenseBack || (DeDriverLicenseBack = {}));
/** German Residence Permit (Aufenthaltstitel), Front side */
export class DeResidencePermitFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeResidencePermitFrontDocumentType;
    }
    /** Birth date (Geburtsdatum) */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Six digit card access number */
    get cardAccessNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardAccessNumber');
    }
    /** Expiry date (Gültig bis) */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Gender (Geschlecht) */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Document ID number (in the top-right corner) */
    get id() {
        return this.document.fields.find((f) => f.type.name === 'ID');
    }
    /** Nationality (Staatsangehörigkeit) */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Photo image */
    get photo() {
        return this.document.fields.find((f) => f.type.name === 'Photo');
    }
    /** Place of issue (Ausstellungsort) */
    get placeOfIssue() {
        return this.document.fields.find((f) => f.type.name === 'PlaceOfIssue');
    }
    /** Remarks (Anmerkungen) */
    get remarks() {
        return this.document.fields.find((f) => f.type.name === 'Remarks');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
    /** Title type (Art des Titels) */
    get titleType() {
        return this.document.fields.find((f) => f.type.name === 'TitleType');
    }
    /** Valid from date (Gültig ab) */
    get validFrom() {
        return this.document.fields.find((f) => f.type.name === 'ValidFrom');
    }
}
/** German Residence Permit (Aufenthaltstitel), Back side */
export class DeResidencePermitBack {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeResidencePermitBackDocumentType;
    }
    /** Address (Anschrift) */
    get address() {
        return this.document.fields.find((f) => f.type.name === 'Address');
    }
    /** Birth date (Geburtsdatum) */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Birthplace (Geburtsort) */
    get birthplace() {
        return this.document.fields.find((f) => f.type.name === 'Birthplace');
    }
    /** Eye color (Augenfarbe) */
    get eyeColor() {
        return this.document.fields.find((f) => f.type.name === 'EyeColor');
    }
    /** Gender (Geschlecht) */
    get gender() {
        return this.document.fields.find((f) => f.type.name === 'Gender');
    }
    /** Height (Größe) */
    get height() {
        return this.document.fields.find((f) => f.type.name === 'Height');
    }
    /** Issuing authority (Ausländerbehörde) */
    get issuingAuthority() {
        return this.document.fields.find((f) => f.type.name === 'IssuingAuthority');
    }
    /** Nationality (Staatsangehörigkeit) */
    get nationality() {
        return this.document.fields.find((f) => f.type.name === 'Nationality');
    }
    /** Raw MRZ text value */
    get rawMRZ() {
        return this.document.fields.find((f) => f.type.name === 'RawMRZ');
    }
    /** Remarks (Anmerkungen) */
    get remarks() {
        return this.document.fields.find((f) => f.type.name === 'Remarks');
    }
    /** The child document of type "MRZ". */
    get mrz() {
        const child = this.document.children.find((c) => c.type.name === 'MRZ');
        return new MRZ(child);
    }
}
/** European Health Insurance Card (EHIC). Supports formats with both four and five lines of data.
 */
export class EuropeanHealthInsuranceCard {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return EuropeanHealthInsuranceCardDocumentType;
    }
    /** Barcode image (only present in some formats) */
    get barcode() {
        return this.document.fields.find((f) => f.type.name === 'Barcode');
    }
    /** Birth date */
    get birthDate() {
        return this.document.fields.find((f) => f.type.name === 'BirthDate');
    }
    /** Card number */
    get cardNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardNumber');
    }
    /** Country code (ISO 3166-1 alpha-2) */
    get countryCode() {
        return this.document.fields.find((f) => f.type.name === 'CountryCode');
    }
    /** Expiry date */
    get expiryDate() {
        return this.document.fields.find((f) => f.type.name === 'ExpiryDate');
    }
    /** Given names */
    get givenNames() {
        return this.document.fields.find((f) => f.type.name === 'GivenNames');
    }
    /** Issuer name */
    get issuerName() {
        return this.document.fields.find((f) => f.type.name === 'IssuerName');
    }
    /** Issuer number */
    get issuerNumber() {
        return this.document.fields.find((f) => f.type.name === 'IssuerNumber');
    }
    /** Personal number */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
    /** Signature image */
    get signature() {
        return this.document.fields.find((f) => f.type.name === 'Signature');
    }
    /** Surname */
    get surname() {
        return this.document.fields.find((f) => f.type.name === 'Surname');
    }
}
/** Front side of the German health insurance card (elektronische Gesundheitskarte).
For the backside, see EuropeanHealthInsuranceCard.
 */
export class DeHealthInsuranceCardFront {
    get document() {
        return this._document;
    }
    constructor(document) {
        if (document.type.name !== this.requiredDocumentType()) {
            throw new Error(`Expected document type ${this.requiredDocumentType()}, got ${document.type.name}`);
        }
        this._document = document;
    }
    requiredDocumentType() {
        return DeHealthInsuranceCardFrontDocumentType;
    }
    /** Six digit card access number */
    get cardAccessNumber() {
        return this.document.fields.find((f) => f.type.name === 'CardAccessNumber');
    }
    /** Issuer name */
    get issuerName() {
        return this.document.fields.find((f) => f.type.name === 'IssuerName');
    }
    /** Issuer number (Versicherung bzw. Kennnummer des Trägers) */
    get issuerNumber() {
        return this.document.fields.find((f) => f.type.name === 'IssuerNumber');
    }
    /** Full name with title */
    get name() {
        return this.document.fields.find((f) => f.type.name === 'Name');
    }
    /** Personal number (Versichertennummer) */
    get personalNumber() {
        return this.document.fields.find((f) => f.type.name === 'PersonalNumber');
    }
}
//# sourceMappingURL=DocumentsModel.js.map